import colors from 'vuetify/lib/util/colors';

export default {
	themes: {
		light: {
			primary: '#31b7bc', // dvergara 05-nov-2021 marketing solicita ese color
			'selected-light': '#d7f1f0', // dvergara 05-nov-2021 marketing solicita rgba(49,183,182,0.2) pero no se soportan transparencias aquí
			secondary: colors.blueGrey.darken1,
			accent: colors.shades.black,
			error: colors.red.darken1,
			success: colors.green.darken2,
			warning: colors.orange.darken2,
		},
		dark: {
			// Nada todavía por acá
		},
	},
};
